import React from 'react'
import { Image } from 'react-bootstrap'

function SImage({alt, source, className,width,height}) {
  return (
    <>
    <Image 
        alt={alt}
        src={source}
        className={className}
        width={width}
        height={height}
    />
    </>
  )
}

export default SImage